<template>
    <nav-tabs :tabs="routes" />
    <router-view></router-view>
</template>

<script>
import NavTabs from "../../components/layouts/NavTabs.vue";

export default {
    components: { NavTabs },
    data() {
        return {
            routes: [
                { label: "Placa", route: "account-portfolio.next-plate" },
                { label: "Placa Atual", route: "account-portfolio.current-plate" },
            ],
        };
    },
};
</script>
